// b99.9.90 — Altitude histogram panel (mirrors ElevationPanel).
// Mutually exclusive with the elevation profile — only one of the
// two ever renders at a time; the orchestrator handles that.

import { Pin } from "lucide-react";
import { useTranslation } from "react-i18next";
import ElevationHistogramWeb from "../ElevationHistogramWeb";

export default function TripOverviewHistogramPanel({
  coordinates,
  height,
  onClose,
  fullscreen = false,
}) {
  const { t } = useTranslation("common");
  return (
    <div className="relative flex-shrink-0" data-testid="trip-overview-histogram-panel">
      <button
        type="button"
        onClick={onClose}
        className="absolute top-2 right-2 z-10 p-1 hover:bg-orange-500/10 rounded text-orange-500"
        data-testid="trip-overview-histogram-pin"
        aria-label={t("map.controls.unpin_histogram", "Desafixar histograma de altitude")}
        title={t("map.controls.unpin_histogram", "Desafixar histograma de altitude")}
      >
        <Pin className="h-4 w-4" fill="currentColor" />
      </button>
      <ElevationHistogramWeb
        coordinates={coordinates}
        height={height}
        position={fullscreen ? "middle" : "bottom"}
      />
    </div>
  );
}
